module.exports = __webpack_public_path__ + "img/ai-weapon4.3f6c7e37.png";